import React from 'react'
import tw from 'twin.macro'
import styled from '@emotion/styled'
import Amex from '../../assets/payment-logos/amex.svg'
import ApplePay from '../../assets/payment-logos/apple-pay.svg'
import GooglePay from '../../assets/payment-logos/google-pay.svg'
import Maestro from '../../assets/payment-logos/maestro.svg'
import MasterCard from '../../assets/payment-logos/mastercard.svg'
import ShopPay from '../../assets/payment-logos/shop-pay.svg'
import Visa from '../../assets/payment-logos/visa.svg'

const Wrapper = styled.div`
  ${tw`flex`}

  svg {
    ${tw`mx-1`}
    width: 32px;
  }
`

const PaymentLogos = () => (
  <Wrapper>
    <Amex />
    <ApplePay />
    <GooglePay />
    <Maestro />
    <MasterCard />
    <ShopPay />
    <Visa />
  </Wrapper>
)

export default PaymentLogos
